import { NgModule } from '@angular/core';
import { PushPipe } from '@ngrx/component';

import { OverlayComponent } from './components/overlay/overlay.component';

@NgModule({
    imports: [PushPipe, OverlayComponent],
    exports: [OverlayComponent],
})
export class SharedModule {}
